import { Link, Icon as NDSIcon, TruncatedText } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const Icon = styled(NDSIcon)`
  position: relative;
  top: 2px;
  left: 2px;
`;

const LinkSpan = styled.span`
  p {
    cursor: pointer;
  }
`;

export default function PackmanagerLink({ packmanagerPath, children, applicationContext }) {
  const { packmanagerUrl } = applicationContext;
  const linkToEntityInPackmanager = `${packmanagerUrl}/${packmanagerPath}`;
  const hasTruncatedText = React.Children.toArray(children).some(
    (child) => React.isValidElement(child) && child.type === TruncatedText,
  );

  return (
    <>
      {packmanagerPath ? (
        <Link
          display={hasTruncatedText ? "inline-flex" : "inline"}
          href={linkToEntityInPackmanager}
          target="_blank"
          underline={false}
        >
          <LinkSpan>{children}</LinkSpan>
          <Icon icon="openInNew" size="20px" />
        </Link>
      ) : (
        children
      )}
    </>
  );
}
